import React, { useState } from "react";
import img from "../assets/images/wafers.png";
import InputBox from "../components/InputBox";
import OTPInput from "react-otp-input";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../utils/utils";

const Login = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [mobile, setMobile] = useState("");
  const [validation, setValidation] = useState({});
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const get_otp = async () => {
    if (!mobile || mobile.length < 10) {
      setValidation({
        ...validation,
        mobilemess: !mobile
          ? "Mobile number is required"
          : "Invalid Mobile Number",
      });
      return;
    }
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", 0);
      body.append("mobile", mobile);
      const responce = await fetch(baseUrl + "login", {
        method: "POST",
        body: body,
      });
      const res = await responce.json();
      setLoading(false);
      if (res.status == 0) {
        toast.success(res.message);
        setShow(true);
      } else {
        toast.error(res.message);
        setShow(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const on_login = async () => {
    if (!mobile || mobile.length < 10 || !otp || otp.length < 4) {
      setValidation({
        ...validation,
        mobilemess: !mobile
          ? "Mobile number is required"
          : mobile.length < 10
          ? "Invalid Mobile Number"
          : "",
        otpmess: !otp || otp.length < 4 ? "otp is required" : "",
      });
      return;
    }
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", 1);
      body.append("mobile", mobile);
      body.append("otp", otp);
      const responce = await fetch(baseUrl + "login", {
        method: "POST",
        body: body,
      });
      const res = await responce.json();
      setLoading(false);
      console.log(res);
      if (res.status == 0) {
        toast.success(res.message);
        localStorage.setItem("user", JSON.stringify(res.userid));
        navigate("/");
        window.location.reload();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <div
      style={{
        height: "90vh",
        width: "100%",
        // backgroundImage: `url(${img})`,
        backgroundSize: "contain",
        backgroundRepeat: "repeat",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        backgroundColor: "#f1f1f1",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          width: "300px",
          borderRadius: 10,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        }}
      >
        <h2 style={{ marginBottom: 20 }}>Login</h2>
        <InputBox
          disabled={show}
          title={"Mobile Number"}
          value={mobile}
          onChange={(e) => {
            e.target.value.length > 10 ||
              setMobile(e.target.value.replace(/\D/g, ""));
            setValidation({
              ...validation,
              mobilemess: "",
            });
          }}
          placeholder={"Enter Mobile Number"}
          mess={validation.mobilemess}
        />
        {show && (
          <OTPInput
            shouldAutoFocus
            value={otp}
            onChange={(v) => {
              setOtp(v);
              setValidation({
                ...validation,
                otpmess: "",
              });
            }}
            numInputs={4}
            renderSeparator={<span> </span>}
            renderInput={(props) => <input {...props} />}
            containerStyle={{ justifyContent: "center" }}
            inputStyle={{ height: 30, width: 30, margin: 10 }}
          />
        )}
        {show && <p style={{ color: "red" }}>{validation.otpmess}</p>}

        <div className="flex df mt" style={{ justifyContent: "center" }}>
          <Button
            title={show ? "Login" : "Get OTP"}
            loading={loading}
            onClick={() => (show ? on_login() : get_otp())}
          />
          {/* <div className="button" onClick={get_otp}>
            {loading ? (
              <Oval
                height={20}
                width={20}
                color="#fff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#fff"
                strokeWidth={4}
                strokeWidthSecondary={4}
              />
            ) : show ? (
              "Login"
            ) : (
              "Get OTP"
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
